/*
 * Copyright (C) 2026 Das Land Schleswig-Holstein vertreten durch den
 * Ministerpräsidenten des Landes Schleswig-Holstein
 * Staatskanzlei
 * Abteilung Digitalisierung und zentrales IT-Management der Landesregierung
 *
 * Lizenziert unter der EUPL, Version 1.2 oder - sobald
 * diese von der Europäischen Kommission genehmigt wurden -
 * Folgeversionen der EUPL ("Lizenz");
 * Sie dürfen dieses Werk ausschließlich gemäß
 * dieser Lizenz nutzen.
 * Eine Kopie der Lizenz finden Sie hier:
 *
 * https://joinup.ec.europa.eu/collection/eupl/eupl-text-eupl-12
 *
 * Sofern nicht durch anwendbare Rechtsvorschriften
 * gefordert oder in schriftlicher Form vereinbart, wird
 * die unter der Lizenz verbreitete Software "so wie sie
 * ist", OHNE JEGLICHE GEWÄHRLEISTUNG ODER BEDINGUNGEN -
 * ausdrücklich oder stillschweigend - verbreitet.
 * Die sprachspezifischen Genehmigungen und Beschränkungen
 * unter der Lizenz sind dem Lizenztext zu entnehmen.
 */
import { Component, Input } from '@angular/core';

@Component({
  selector: 'ods-link',
  host: { class: 'block w-full' },
  template: `<a
    [target]="openInNewTab ? '_blank' : '_self'"
    [href]="url"
    class="text-text focus-visible:border-primary block rounded-md border border-transparent hover:bg-neutral-100 focus-visible:outline-hidden dark:hover:bg-neutral-700"
    [attr.data-test-id]="linkTestId"
  >
    <ng-content />
  </a>`,
})
export class LinkComponent {
  @Input({ required: true }) url!: string;
  @Input() openInNewTab: boolean = false;
  @Input() linkTestId: string | null = null;
}
